import React, { useEffect } from "react";
import Animated, {
  cancelAnimation,
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";

type AnimatedFilterSectionProps = {
  visible: boolean;
  children: React.ReactNode;
  maxHeight?: number;
  durationMs?: number;
};

const AnimatedFilterSection: React.FC<AnimatedFilterSectionProps> = ({
  visible,
  children,
  maxHeight = 260,
  durationMs = 220,
}) => {
  const progress = useSharedValue(visible ? 1 : 0);

  useEffect(() => {
    progress.value = withTiming(visible ? 1 : 0, {
      duration: durationMs,
      easing: Easing.out(Easing.cubic),
    });

    return () => cancelAnimation(progress);
  }, [durationMs, progress, visible]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: progress.value,
      maxHeight: maxHeight * progress.value,
      marginTop: 12 * progress.value,
      transform: [{ translateY: -6 + 6 * progress.value }],
    };
  }, [maxHeight]);

  return (
    <Animated.View style={[{ overflow: "hidden" }, animatedStyle]}>
      {children}
    </Animated.View>
  );
};

export default React.memo(AnimatedFilterSection);
